import { Checkbox, Row } from "@/components";
import { SORT_COLUMNS } from "@/pages/requests/components/users/components/constants";
import { SortButton } from "@/pages/requests/components/users/components/sort-button";
import {
  Filter,
  UserSearch,
} from "@/pages/requests/components/users/components/table-filters";
import {
  prepareFilterOptions,
  prepareStatusFilterOptions,
} from "@/pages/requests/components/users/utils";
import clsx from "clsx";
import { FC, useCallback, useEffect, useRef } from "react";
import styles from "../../styles.scss";
import { TableHeaderProps } from "../../types";

export const TableHeader: FC<TableHeaderProps> = ({
  data,
  appliedFilters,
  searchValue,
  isSelectedAll,
  isPartialSelected,
  isInbox,
  sortDirections,
  selectedOptions,
  onSortBy,
  onSearch,
  onToggleAll,
  onFilterChange,
  onApplyFilters,
}) => {
  const selectAllRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (selectAllRef.current) {
      selectAllRef.current.indeterminate = isPartialSelected;
    }
  }, [isPartialSelected]);

  const filterOptions = (key: SORT_COLUMNS, id: string) => {
    if (data) {
      if (key === SORT_COLUMNS.STATUS) {
        return prepareStatusFilterOptions(data);
      }

      return prepareFilterOptions(data, key, id);
    }

    return [];
  };

  const renderSortButton = useCallback(
    (key: SORT_COLUMNS) => {
      return (
        <SortButton
          _key={key}
          // onSortBy={onSortBy}
          sortDirections={sortDirections}
        />
      );
    },
    [sortDirections],
  );

  return (
    <>
      {!isInbox && (
        <Row className={styles.tableHeaderFilters}>
          <div>
            <UserSearch searchValue={searchValue} onSearch={onSearch} />
          </div>
          <div>
            <Filter
              name={SORT_COLUMNS.NATIONALITY}
              appliedFilters={appliedFilters}
              // TODO Fix me
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-expect-error
              data={filterOptions(
                SORT_COLUMNS.NATIONALITY,
                "WorkerEidUnifiedNumber",
              )}
              placeholder="Filter Nationality"
              selectedOptions={selectedOptions}
              onFilterChange={onFilterChange}
              onApplyFilters={onApplyFilters}
            />
            <Filter
              name={SORT_COLUMNS.JOB_TITLE_EN}
              appliedFilters={appliedFilters}
              // TODO Fix me
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-expect-error
              data={filterOptions(
                SORT_COLUMNS.JOB_TITLE_EN,
                "WorkerEidUnifiedNumber",
              )}
              placeholder="Filter Job Title"
              selectedOptions={selectedOptions}
              onFilterChange={onFilterChange}
              onApplyFilters={onApplyFilters}
            />
            <Filter
              name={SORT_COLUMNS.STATUS}
              appliedFilters={appliedFilters}
              // TODO Fix me
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-expect-error
              data={filterOptions(
                SORT_COLUMNS.STATUS,
                "WorkerEidUnifiedNumber",
              )}
              placeholder="Filter Status"
              selectedOptions={selectedOptions}
              onFilterChange={onFilterChange}
              onApplyFilters={onApplyFilters}
            />
          </div>
        </Row>
      )}

      <Row
        className={clsx(styles.tableHeader, isInbox && styles.tableHeader6)}
        style={{
          gridTemplateColumns: isInbox
            ? "repeat(5, 1fr) 65px"
            : "48px repeat(7, 1fr) 65px",
          padding: isInbox ? "1rem" : "0px 10px 0 0",
        }}
      >
        {!isInbox && (
          <div className={styles.colHeader}>
            <Checkbox
              ref={selectAllRef}
              id="selectAll"
              name="selectAll"
              title="Select All"
              className={styles.checkbox}
              defaultValue={`${isSelectedAll}`}
              onChange={onToggleAll}
            />
          </div>
        )}

        <div className={styles.colHeader}>
          <div className={styles.colHeaderRow}>Worker ID</div>
        </div>
        <div className={styles.colHeader}>
          <div
            className={styles.colHeaderRow}
            onClick={() => onSortBy(SORT_COLUMNS.NAME_EN)}
          >
            <span>Name (English)</span>
            {renderSortButton(SORT_COLUMNS.NAME_EN)}
          </div>
        </div>
        {!isInbox && (
          <div className={styles.colHeader}>
            <div
              className={styles.colHeaderRow}
              onClick={() => onSortBy(SORT_COLUMNS.NAME_AR)}
            >
              <span>Name (Arabic)</span>
              {renderSortButton(SORT_COLUMNS.NAME_AR)}
            </div>
          </div>
        )}

        <div className={styles.colHeader}>
          <div
            className={styles.colHeaderRow}
            onClick={() => onSortBy(SORT_COLUMNS.NATIONALITY)}
          >
            <span>Nationality</span>
            {renderSortButton(SORT_COLUMNS.NATIONALITY)}
          </div>
        </div>
        <div className={styles.colHeader}>
          <div
            className={styles.colHeaderRow}
            onClick={() => onSortBy(SORT_COLUMNS.JOB_TITLE_EN)}
          >
            <span>Job Title</span>
            {renderSortButton(SORT_COLUMNS.JOB_TITLE_EN)}
          </div>
        </div>
        <div className={styles.colHeader}>
          <div className={styles.colHeaderRow}>Emirates ID</div>
        </div>
        {!isInbox && (
          <div className={styles.colHeader}>
            <div className={styles.colHeaderRow}>Passport #</div>
          </div>
        )}

        <div className={styles.colHeader}>
          <div
            className={styles.colHeaderRow}
            onClick={() => onSortBy(SORT_COLUMNS.STATUS)}
          >
            <span>Status</span>
            {renderSortButton(SORT_COLUMNS.STATUS)}
          </div>
        </div>
      </Row>
    </>
  );
};
